// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"241":"cefcbf9c","366":"38f78929","488":"f3a8af73","682":"160da318","715":"ae35eff0","972":"86b65682"}[chunkId] + ".chunk.js";
};